import React, { FC } from 'react';
import clsx from 'classnames';
import { ButtonProps } from './button.types';

import styles from './button.module.scss';

export const Button: FC<ButtonProps> = React.memo((props: any) => {
  const themeStyle = {
    outline: 'outlineTheme',
    primary: 'primaryTheme',
  };

  const { children, className, disabled, label, theme, ...other } = props;
  // @ts-ignore
  const themeType = themeStyle[theme];

  return (
    // eslint-disable-next-line react/button-has-type
    <button
      className={clsx(
        styles.container,
        {
          [styles[themeType]]: themeType,
          [styles.disabled]: disabled,
        },
        className,
      )}
      disabled={disabled}
      {...other}>
      {label}
      {children}
    </button>
  );
});

Button.defaultProps = { theme: 'primary', type: 'button' };
